module.exports = __webpack_public_path__ + "img/fi-doc.5b5819ea.svg";